/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Camera_Settings_Username_RequiredInputs */

const vi_grower_camera_settings_username_required = /** @type {(inputs: Grower_Camera_Settings_Username_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập tên đăng nhập camera`)
};

/**

* @param {Grower_Camera_Settings_Username_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_camera_settings_username_required = /** @type {((inputs?: Grower_Camera_Settings_Username_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Camera_Settings_Username_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_camera_settings_username_required(inputs)
});